import React from 'react';
import { connect } from 'react-redux';
import { Prompt } from 'react-router-dom';
import { lifecycle, withHandlers, withStateHandlers } from 'recompose';
import { compose } from 'redux';
import { LoadingButton } from '../../../../components';
import TestingPlan from './components/testingPlan';
import UserSelection from './components/userSelection';

const TestingSetControl = ({ testingSet, isRunningTest, runTest, setUsers, users, onTestCompleted }) => {
  return <div id='testing-set-control'>
    <Prompt when={isRunningTest} message={(nextLocation) => {
      return false
    }} />
    <h3 id='name'>
      {testingSet.name}
    </h3>
    <UserSelection onChange={setUsers} />
    <TestingPlan endpoints={testingSet.endpoints} users={users} isRunningTest={isRunningTest} onComplete={onTestCompleted} />
    <div id='control'>
      {
        users.length > 0 ?
          [
            <LoadingButton key={1} {...{
              onClick: () => runTest(1),
              text: 'run',
              loading: isRunningTest
            }} />,
            <LoadingButton key={2} {...{
              onClick: () => runTest(10),
              text: 'run 10 times',
              loading: isRunningTest
            }} />,
            <LoadingButton key={3} {...{
              onClick: () => runTest(100),
              text: 'run 100 times',
              loading: isRunningTest
            }} />
          ] :
          null
      }
    </div>
  </div>
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(
    {
      runTimes: 0,
      isRunningTest: false,
      users: []
    },
    {
      setRunningTimes: () => (runTimes) => ({
        runTimes
      }),
      setRunningTest: () => (isRunningTest) => ({
        isRunningTest
      }),
      setUsers: () => (users) => ({ users })
    }
  ),
  withHandlers({
    runTest: ({ setRunningTimes }) => (runTimes) => {
      setRunningTimes(runTimes)
    },
    onTestCompleted: ({ setRunningTest }) => () => {
      setRunningTest(false)
    }
  }),
  lifecycle({
    componentDidUpdate() {
      const {
        runTimes,
        isRunningTest,
        setRunningTimes,
        setRunningTest
      } = this.props

      if (!isRunningTest && runTimes > 0) {
        setRunningTimes(runTimes - 1)
        setRunningTest(true)
      }
    }
  })
)(TestingSetControl)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/testing-portal/pressure-test/testingSetControl.js